import * as yup from 'yup'

const schema = includeSpouse =>
  yup.object({
    planningWorkPartTimeClient: yup
      .boolean()
      .nullable()
      .required('Select one')
      .oneOf([true, false], 'Select one'),
    durationStartingAgeClient: yup
      .number()
      .nullable()
      .when('planningWorkPartTimeClient', {
        is: true,
        then: schema =>
          schema
            .required('Duration: starting age is a required field')
            .test(
              'is-not-less-than-retirement-age',
              'Starting age for part-time work during retirement may not begin before the retirement age',
              function (value) {
                return this.parent.clientRetirement <= value
              }
            ),
        otherwise: schema => schema,
      }),
    durationStoppingAgeClient: yup
      .number()
      .nullable()
      .when('planningWorkPartTimeClient', {
        is: true,
        then: schema =>
          schema
            .required('Duration: stopping age is a required field')
            .test(
              'is-not-less-than-starting-age',
              'Stopping age cannot be before starting age',
              function (value) {
                return this.parent.durationStartingAgeClient <= value
              }
            ),
        otherwise: schema => schema,
      }),
    clientIncome: yup
      .number()
      .nullable()
      .when('planningWorkPartTimeClient', {
        is: true,
        then: schema =>
          schema
            .required('Annual income is required')
            .min(1, 'Amount must be between $1 and $10,000,000')
            .max(9999999, 'Amount must be between $0 and $10,000,000'),
        otherwise: schema => schema,
      }),
    planningWorkPartTimeSpouse: yup
      .boolean()
      .nullable()
      .test('required-if-includeSpouse', 'Select one', function (value) {
        if (includeSpouse) {
          return value === true || value === false
        }
        return true
      }),
    durationStartingAgeSpouse: yup
      .number()
      .nullable()
      .when('planningWorkPartTimeSpouse', {
        is: true,
        then: schema =>
          schema
            .required('Duration: starting age is a required field')
            .test(
              'is-not-less-than-retirement-age',
              'Starting age for part-time work during retirement may not begin before the retirement age',
              function (value) {
                return this.parent.spouseRetirement <= value
              }
            ),
        otherwise: schema => schema,
      }),
    durationStoppingAgeSpouse: yup
      .number()
      .nullable()
      .when('planningWorkPartTimeSpouse', {
        is: true,
        then: schema =>
          schema
            .required('Duration: stopping age is a required field')
            .test(
              'is-not-less-than-starting-age',
              'Stopping age cannot be before starting age',
              function (value) {
                return this.parent.durationStartingAgeSpouse <= value
              }
            ),
        otherwise: schema => schema,
      }),
    spouseIncome: yup
      .number()
      .nullable()
      .when('planningWorkPartTimeSpouse', {
        is: true,
        then: schema =>
          schema
            .required('Annual income is required')
            .min(1, 'Amount must be between $1 and $10,000,000')
            .max(9999999, 'Amount must be between $0 and $10,000,000'),
        otherwise: schema => schema,
      }),
  })

export { schema }
